import React, {useState} from 'react';
import { useOutletContext, useParams} from "react-router-dom";
import {HowIWorkBannerStyled, HowIWorkContainerStyled, HowIWorkSectionStyled} from "../../../styled/HowIWork";
import {FaLongArrowAltRight, FaYoutube, FaRegPlayCircle} from "react-icons/fa";
import Companies from "../TopCompanies/Companies";
import Testimonials from "../Testimonials/Testimonial";
import FAQ from "../FAQ/FAQ";
import SubscriptionPlans from "../SubscriptionPlans/Subscriptions";
import featureTutorial from "./data";
import ProcessStep from "../../StepProcess/ProcessStep";
import Button from "../Buttons/Button";
import Footer from "../Footer/Footer";


const HowIWork = () => {
    const params = useParams();
    const { handleTryFree } = useOutletContext();
    const [orientation, setOrientation] = useState(false);
    const [playVideo, setPlayVideo] = useState(false);
    const {feature} = params;
    const isFeatureAvailable = featureTutorial.filter(item=>item.slug === feature).length > 0;


    return (
        <>
            {
                isFeatureAvailable &&
                featureTutorial.filter(item => item.slug === feature).map((item, index) => (
                    <HowIWorkContainerStyled key={index}>
                        <HowIWorkBannerStyled>
                            <h1>
                                {item.title} with{' '}
                                <span className="bubble-text">Bubble Ai</span>
                            </h1>
                            <p>{item.description}</p>
                            <div className="buttonContainer">
                                <Button secondary={true} width="100%" clickHandle={() => setOrientation(!orientation)}>
                                    Watch Video <FaYoutube/>
                                </Button>
                                <Button primary={true} width="100%" clickHandle={() => handleTryFree(item.link)}>
                                    Try it for Free <FaLongArrowAltRight/>
                                </Button>
                            </div>
                        </HowIWorkBannerStyled>

                        <HowIWorkSectionStyled orientation={orientation} video={playVideo.toString()}>
                            <h2>How It Works</h2>
                            <div className="switcher">
                                <div className="card">
                                    {item.cards.map((step, index) => (
                                        <ProcessStep
                                            key={index}
                                            number={index + 1}
                                            {...step}
                                        />
                                    ))}
                                </div>
                                <Button
                                    primary={true}
                                    width="50%"
                                    link={item.link}

                                >
                                    Try it Now
                                </Button>
                                <div className="video">
                                    <iframe
                                        src={item.videoSource}
                                        title="YouTube video player"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                    />
                                    <span className="contentOverlay">
                                        <p style={{fontSize: '1.2rem'}}>Watch How I Work</p>
                                        <FaRegPlayCircle onClick={() => setPlayVideo(!playVideo)} fontSize={65} color={"#fff"}/>
                                    </span>

                                </div>

                            </div>


                        </HowIWorkSectionStyled>
                    </HowIWorkContainerStyled>

                ))
            }

            {
                !isFeatureAvailable &&
                <HowIWorkContainerStyled style={{padding: '8rem', textAlign: 'center', borderTop: '0.01rem solid #5fbec5'}}>
                    <h1 style={{fontSize: '4rem', fontWeight:'900'}}>404</h1>Page Not Found</HowIWorkContainerStyled>
            }



            <Testimonials/>

            <Companies/>

            <FAQ/>

            <SubscriptionPlans/>

            <Footer/>

        </>

    );

}

export default HowIWork;